import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import CKEditor from "react-ckeditor-component";
import $ from 'jquery';
import Header from './../../Header';
import HeaderMob from './../../HeaderMob';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
class ViewSnippet extends Component {
    constructor(props) {
        super(props);
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            snippet_history: [],
            notes: [],
            snippet: [],
            week: '',
            owner_name: '',
            formatted_owners: [],
            note: '',
            owners: [],
            errors: {},
            apiUrl: this.decryptconfigdata('apiUrl'),
            userEmail: has_local_data ? localdata.user_email : '',
            userId: has_local_data ? localdata.user_id : '',
            userName: has_local_data ? localdata.user_name : '',
            userAuthKey: has_local_data ? localdata.user_key : '',
            scrol: 1
        };
        this.AddNote = this.AddNote.bind(this);
        this.ckOnChange1 = this.ckOnChange1.bind(this);
    }

    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }

    rawjsonparse(findresponse, flg) {
        return findresponse;
    }

    ckOnChange1(evt) {
        var ckContent = evt.editor.getData();
        if (this.state.note.toLowerCase() != ckContent.toLowerCase()) {
            this.setState({
                note: ckContent
            })
            var obj = this;
            setTimeout(function () {
                ckContent = ckContent.replace(/<\/p>$/, ""); //remove last </p>
                var nameRegex = /@[a-zA-Z]+$/;
                var matches = ckContent.match(nameRegex); //select characters having @
                if (matches && matches.length > 0) {
                    var indx = matches['index'];
                    var query = matches[0].replace('@', '');
                    if (query) {
                        var result = [];
                        var filterObj = obj.state.owners.filter(function (e) {
                            if (e.name.toLowerCase().includes(query.toLowerCase())) {
                                result.push(e.name);
                            }
                        });
                        var mtchitems = '';
                        if (result.length > 0) {
                            for (var i in result) {
                                mtchitems += '<li class="auto-suggest-li" style="padding:5px;cursor:pointer;background:#ccc;margin-bottom:1px;" >' + result[i] + '</li>';
                                if (i == result.length - 1) {
                                    mtchitems = '<ul style="list-style:none" class="auto-suggest-ul">' + mtchitems + '</ul>';
                                    document.getElementById('note_autoseggestion').innerHTML = mtchitems;
                                    $('.auto-suggest-li').on('click', function (event) {
                                        var final_string = ckContent.substring(0, indx) + "@" + event.target.innerText.trim();
                                        evt.editor.setData(final_string);
                                        obj.setState({
                                            note: final_string,
                                        })

                                        document.getElementById('note_autoseggestion').innerHTML = "";
                                        evt.editor.focus();
                                    });
                                }
                            }
                        } else {
                            document.getElementById('note_autoseggestion').innerHTML = "";
                        }
                    }
                } else {
                    document.getElementById('note_autoseggestion').innerHTML = "";
                }
            }, 300);
        } else {
            evt.editor.focus();
        }
    }

    getReporter() {
        if (this.state.owner_name) {
            return (
                <div class="er_moniter">
                    <div class="text-inded"><Link to={`/viewEmployee/${this.state.formatted_owners[this.state.owner_name].id}`} name={"max"}>{this.state.formatted_owners[this.state.owner_name].name}</Link></div>
                    <div class="pro_image pull-left">
                        {this.state.formatted_owners[this.state.owner_name].attachment_url ? <img src={this.state.formatted_owners[this.state.owner_name].attachment_url + this.state.formatted_owners[this.state.owner_name].attachment} /> : <span class="profile_first_name">{this.state.formatted_owners[this.state.owner_name].img_name}</span>}
                    </div>
                </div>
            )
        }
    }

    goBack() {
        window.history.back();
    }

    AddNote() {
        let errors = {};
        document.getElementById("add_note").innerHTML = "Sending....";
        const fd = new FormData;
        document.getElementById("add_note").disabled = true;
        fd.append('note', this.state.note);
        fd.append('snippet_id', this.props.match.params.snippetId);
        fetch(this.state.apiUrl + '/ErRest/AddSnippetNote/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                document.getElementById("add_note").disabled = false;
                document.getElementById("add_note").innerHTML = "Add Note";
                if (findresponse.code == 200) {
                    this.setState({ message: findresponse.msg }, function () {
                        errors["note"] = "";
                        this.setState({ errors: errors, note: '' });
                        // this.getSnippetDetails();
                        window.location.href = '/viewSnippet/' + this.props.match.params.snippetId;
                    });
                } else {
                    errors["note"] = findresponse.msg;
                    this.setState({ errors: errors });
                    this.setState({ message: findresponse.msg })
                }
            })
    }

    getSnippetDetails() {
        document.getElementById('loader-new').classList.remove("hidden");
        document.getElementById('intranet_body').classList.add("hidden");
        fetch(this.state.apiUrl + '/ErRest/viewSnippet/id/' + this.props.match.params.snippetId + '/userId/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((responseJson) => {
                responseJson = this.rawjsonparse(responseJson, 1);
                document.getElementById('loader-new').classList.add("hidden");
                document.getElementById('intranet_body').classList.remove("hidden");
                if (responseJson.error == 1) {
                    window.location.href = '/Unauthorized';
                } else {
                    this.setState({
                        snippet: responseJson.snippet,
                        week: responseJson.week,
                        owner_name: responseJson.owner_name,
                        formatted_owners: responseJson.formatted_owners,
                        owners: responseJson.owners,
                        notes: responseJson.notes,
                        snippet_history: responseJson.snippet_history,
                        other_owner:responseJson.snippet[0]['user_id'],
                        scrol: this.state.scrol + 1
                    })
                }
                if(this.state.scrol <= 2)
            {

            const { location:{ pathname, hash}} = this.props;
            const element = document.getElementById(hash.replace("#",""));

            setTimeout( () => {
                window.scrollTo({
                    behavior: element ? "smooth" : 'auto',
                    top: element ? element.offsetTop : 0
                })
            })
        }
        else
        {
            return false;
        }
            })
    }

    onChangeSnippetTitle(propertyName, event) {
        const snippet = this.state.snippet;
        snippet[event.target.name][propertyName] = event.target.value;
        this.setState({ snippet: snippet });
    }

    snippet_title(id) {
        document.getElementById('snippet_' + id).classList.remove("hidden");
        document.getElementById('snippet_title_' + id).classList.add("hidden");
    }

    onSubmitSnippetTitleClick(id) {
        let errors = {};
        const fd = new FormData;
        var title = document.getElementById('snippet_title_text_' + id).value
        fd.append('title', title);
        if (title.trim() != '' && title.length != 0) {
            fetch(this.state.apiUrl + '/ErRest/ChangeSnippetTitle/id/' + id + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
                method: 'POST',
                dataType: 'json',
                body: fd,
            })
                .then((Response) => Response.json())
                .then((findresponse) => {
                    findresponse = this.rawjsonparse(findresponse, 1);
                    if (findresponse.code == 200) {
                        this.setState({ errors: '' }, function () {
                            this.getSnippetDetails();
                            document.getElementById('snippet_' + id).classList.add("hidden");
                            document.getElementById('snippet_title_' + id).classList.remove("hidden");
                        });
                    }
                })
        }
        else {
            errors['snippetTitle_error_' + id] = "This field is required.";
            this.setState({ errors: errors });
        }
    }

    getHistoryTitle(type, old_value, new_value) {
        if (type == 1) {
            return 'Snippet Created'
        } else if (type == 2) {
            return ('Note Added : ' + new_value)
        } else if (type == 3) {
            return 'Snippet Updated'
        } else if (type == 4) {
            return ('Note Updated : ' + old_value)
        } else if (type == 5) {
            return ('Snippet Deleted : ' + old_value)
        }
    }

    getHistoryDesc(type, old_value, new_value) {
        if (type == 1) {
            return ''
        } else if (type == 2) {
            return ''
        } else if (type == 3) {
            return old_value + ' => ' + new_value
        } else if (type == 4) {
            return (
                <Link to={`/SnippetHistoryRevision/${this.props.match.params.snippetId}/noteId/${old_value}`} name={"max"} target="_blank"><span className="color-sky">View Revision</span></Link>
            )
        }
    }

    onSnippetTextClick(id,key) {
        if(key==0){
            alert('Not deleted this row');
            return false;
        }
        let errors = {};
        document.getElementById('snippet_' + id).classList.add("hidden");
        document.getElementById('snippet_title_' + id).classList.remove("hidden");
        fetch(this.state.apiUrl + '/ErRest/TitleDelete/id/' + id + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: '',
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                if (findresponse.code == 200) {
                    this.setState({ errors: '' }, function () {
                        this.getSnippetDetails();
                        document.getElementById('snippet_' + id).classList.add("hidden");
                        document.getElementById('snippet_title_' + id).classList.remove("hidden");
                    });
    }
            })
        //errors["snippetTitle_error_" + id] = "";
        //this.setState({ errors: errors });
    }

    NoteEditCondition(id, note) {
        return (
            <a href="javascript:void(0)" onClick={() => this.setNote(id, note)}> <i class="fa fa-edit"></i></a>
        )
    }

    setNote(id, note) {
        localStorage.setItem('ticket_note', note);
        this.props.history.push('/NoteSnippetEdit/' + id);
    }
    insertSnippet(e) {
        document.getElementById("add_request").innerHTML = "Sending....";
        var nodes1 = document.querySelectorAll('input[type="text"].multi_title');
        const fd = new FormData;
        for (let i in nodes1) {
            let value = nodes1[i].value;
            if (value !== null && typeof value !== "undefined" && value.trim() !== "") {
                fd.append("multi_title[]", value);
            }
        }
        document.getElementById("add_request").disabled = true;
        //fd.append('ticket_inputs', JSON.stringify(this.state));
         fetch(this.state.apiUrl + '/ErRest/InsertupdSnippet/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId + '/uniqueid/' + this.props.match.params.snippetId, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                document.getElementById("add_request").innerHTML = "Submit";
                if (findresponse.code == 200) {
                    this.setState({ message: findresponse.msg }, function () {
                        window.location.href = '/viewSnippet/' + this.props.match.params.snippetId;
                        document.getElementById("add_request").disabled = false;
                    });
                } else {
                    this.setState({ message: findresponse.msg })
                    document.getElementById("add_request").disabled = false;
                }
            })
    }
    componentDidMount() {
        document.title = 'Snippet';
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }
        this.getSnippetDetails();
        var max_fields = 10;
        var wrapper = $("#extra_added_snippet_inputs");
        var x = 1;
        $(document).on("click", ".add_form_field", function (e) {
            e.preventDefault();
            if (x < max_fields) {
                x++;
                let currentVal = $("#first_value").val();
                currentVal = (currentVal.trim() !== "") ? currentVal : '';
                $("#first_value").val('');
                $(wrapper).append('<div class="snipet_bar_new"><input type="text" name="multi_title[]" value="' + currentVal + '" class="multi_title form-control" /><i class="far fa-minus-circle delete color-sky"></i></div>'); //add input box
    }
            else {
                alert('You Reached the limits')
            }
        });

        $(wrapper).on("click", ".delete", function (e) {
            e.preventDefault(); $(this).parent('.snipet_bar_new').remove(); x--;
        })
    }

    render() {
        return (
            <div>
                <Header brecum_name="Snippet Detail" brecum_page="Snippet Detail" />
                <div class="right_col">
                    <div class="ticket_list">
                        <div class="loader-new" id="loader-new"></div>
                        <div className="intranet_body hidden" id="intranet_body">
                            <div class="title mob er_ids"><div class="er_id"><span class="er">Snippet : </span><HeaderMob  /></div></div>
                                <div class="request_details er row margin_top_less">
                                    <div class="col-md-9 col-xs-12">
                                        <div class="form-section">
                                            <div class="details">
                                                <div class="details_title">Week</div>
                                                <div class="details_des">{this.state.week}</div>
                                            </div>
                                        <div class="details">
                                            {this.state.snippet.length == 1 ? <div class="details_title m_t_10">Snippet</div> : <div class="details_title">Snippets</div>}
                                                <div class="details_des">
                                                    {
                                                        this.state.snippet.map((snippet, key) =>
                                                            <div class="snippet_bar_view">
                                                        {this.state.userId==this.state.other_owner?<div id={"snippet_title_" + snippet.id} className={"snippet_title form-control text-inded"} onClick={() => this.snippet_title(snippet.id)}>{snippet.title}</div>:<div id={"snippet_title_" + snippet.id} className={"snippet_title form-control text-inded"}>{snippet.title}</div>}
                                                                <div id={"snippet_" + snippet.id} className={"hidden snippet_" + snippet.id}>
                                                                <textarea type="text" name={key} className="form-control" id={"snippet_title_text_" + snippet.id} value={snippet.story_title} onChange={this.onChangeSnippetTitle.bind(this, 'story_title')} />
                                                                {this.state.userId==this.state.other_owner? <div class="snipet_edit">
                                                                        <button type="button" class="color-sky" onClick={() => this.onSubmitSnippetTitleClick(snippet.id)} ><i class="far fa-check-circle"></i></button>
                                                                    <button type="button" class="color-red" onClick={() => this.onSnippetTextClick(snippet.id,key)} ><i class="far fa-times-circle"></i></button>
                                                            </div>:''}
                                                                    </div>
                                                                {this.state.errors["snippetTitle_error_" + snippet.id] ? <div class="form-group">
                                                                    <span class="error">{this.state.errors["snippetTitle_error_" + snippet.id]}</span>
                                                                </div> : ''}
                                                            </div>
                                                        )
                                                    }
                                                     <div class="snippet_bar_view">
                                                      <div id='extra_added_snippet_inputs'></div>
                                                    {this.state.userId==this.state.other_owner?<div class="snipet_bar_new" >
                                                           <div class="snippet_common"> <input type="text" id='first_value' name="multi_title[]" class="multi_title form-control"/></div><i class="far fa-plus-circle color-sky add_form_field"></i>
                                                             <span className="error">{this.state.message}</span>
                                                   </div>:''}
                                                     
                                                </div>
                                          {this.state.userId==this.state.other_owner?<button type="submit" name="add_request" id="add_request" class="btn btn-sky mob-btn" onClick={() => this.insertSnippet()}>Submit</button> :''}
                                            </div>
                                                
                                        </div>
                                        </div>
                                        <div class="request_details">
                                            <div id="exTab1">
                                                <ul class="nav nav-pills">
                                                    <li class="active"><a href="#note" data-toggle="tab">Notes</a></li>
                                                    <li><a href="#history" data-toggle="tab">History</a></li>
                                                </ul>
                                            </div>
                                            <div class="tab-content customer-tab clearfix">
                                                <div className="tab-pane active" id="note">
                                                    <div class="row">
                                                        <div className="form-section ckeditor">
                                                            <CKEditor
                                                                activeClass="p10"
                                                                name='note'
                                                                content={this.state.note}
                                                                events={{
                                                                    "change": this.ckOnChange1
                                                                }}
                                                            />
                                                            <div id='note_autoseggestion'></div>
                                                            <span class="error">{this.state.errors["note"]}</span>
                                                        </div>
                                                        <div className="form-section ckeditor">
                                                            <button type="submit" name="add_note" id="add_note" className="btn btn-sky mob-btn" onClick={() => this.AddNote()}>Add Note</button>
                                                        <button type="button" className="btn btn-blue hidden-sm" onClick={() => this.goBack()} >Back</button>
                                                        </div>
                                                    </div>
                                                    <div className="feedback">
                                                        {this.state.notes.length > 0 ?
                                                            <h5 class="title"><span>View Note</span></h5>
                                                            : ''}
                                                        {
                                                            this.state.notes.map((data, key) =>
                                                                <div class="sub_feedback" id={'note' + data.id}>
                                                                    <div class="main">
                                                                        <div class="pro_image">
                                                                            {this.state.formatted_owners[data.user_id].attachment_url ? <img src={this.state.formatted_owners[data.user_id].attachment_url + this.state.formatted_owners[data.user_id].attachment} /> : <span class="profile_first_name">{this.state.formatted_owners[data.user_id].img_name}</span>}
                                                                        </div>
                                                                        <div class="fa-icon tooltips">
                                                                        {this.NoteEditCondition(data.id, data.note)}
                                                                        </div>
                                                                    <h6><Link to={`/viewEmployee/${data.user_id}`} name={"max"}>{data.owner_name}</Link></h6>
                                                                        <span class="date">{data.created_date}</span>
                                                                    </div>
                                                                    <div class="sub">
                                                                        <a href={'#note' + data.id} key={key} to={data.id} name={'note' + data.id}><span>Note {data.id}</span></a>
                                                                        <div class="note_list" dangerouslySetInnerHTML={{ __html: data.note }} />
                                                                    </div>
                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                                </div>
                                                <div class="tickets tab-pane " id="history">
                                                    <div className="feedback">
                                                        {this.state.snippet_history.length > 0 ?
                                                            <h5 class="title"><span>Snippet History</span></h5>
                                                            : ''}
                                                        <ul class="tickets_head">
                                                            <li class="intra_col_25">Date</li>
                                                            <li class="intra_col_25">User</li>
                                                            <li class="intra_col_25">Field</li>
                                                            <li class="intra_col_25">Change</li>
                                                        </ul>
                                                        {
                                                            this.state.snippet_history.map((ErHistory, key) =>
                                                                <ul class="tickets_number">
                                                                <li class="intra_col_25">{ErHistory.date_modified} </li>
                                                                    <li class="intra_col_25">{this.state.formatted_owners[ErHistory.user_id].name}</li>
                                                                    <li class="intra_col_25">{this.getHistoryTitle(ErHistory.type, ErHistory.old_value, ErHistory.new_value)}</li>
                                                                    <li class="intra_col_25">{this.getHistoryDesc(ErHistory.type, ErHistory.old_value, ErHistory.new_value)}</li>
                                                                </ul>
                                                            )
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3 col-xs-12">
                                        <div class="form-section">
                                            <div class="details er_member">
                                                <div class="details_title">Owner</div>
                                                <div class="details_des">{this.getReporter()}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default ViewSnippet;


// WEBPACK FOOTER //
// ./src/components/er/viewSnippet.js